// Helper function to check if a date falls within the current year
const isYearToDate = (date, asOfDate) => {
    const currentDate = asOfDate || new Date(); // Use asOfDate if provided, otherwise use the current date
    const currentYearStart = new Date(currentDate.getFullYear(), 0, 1);

    return date >= currentYearStart && date <= currentDate;
};

export default isYearToDate;
